// extracted by mini-css-extract-plugin
export default {"container":"Card_container__DbXh1","cover":"Card_cover__RMGfy","favorite":"Card_favorite__mfXCn","link":"Card_link__379CA"};